import { useStore } from 'effector-react'
import * as React from 'react'

import {
  $cardVerificationRequest,
  cardVerificationRequestMounted,
} from './model'

export const useCardVerificationRequest = () => {
  const cardVerificationRequest = useStore($cardVerificationRequest)

  React.useEffect(() => {
    cardVerificationRequestMounted()
  }, [])

  return cardVerificationRequest
}
